import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeaderboardBannerDetail} from '../../../apis/banner/getLeaderboardBannerDetail'

const useQueryLeaderboardBannerDetail = (id: string) => {
    const {data, refetch} = useQuery({
        enabled: !!id && id !== 'create',
        queryKey: QueryCacheKeys.advertisement.getLeaderboardBannerDetail(id),
        queryFn: async () => {
            const {data} = await getLeaderboardBannerDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data: data, refetch}
}

export default useQueryLeaderboardBannerDetail
